import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Insights from "./pages/Insights";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import GovernmentSolutions from "./pages/GovernmentSolutions";
import RealEstateSolutions from "./pages/RealEstateSolutions";
import LuxuryFashionProcurement from "./pages/LuxuryFashionProcurement";
import AutomotiveProcurement from "./pages/AutomotiveProcurement";
import MedicalProcurement from "./pages/MedicalProcurement";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/about" element={<About />} />
          <Route path="/government-solutions" element={<GovernmentSolutions />} />
          <Route path="/real-estate-solutions" element={<RealEstateSolutions />} />
          <Route path="/luxury-fashion" element={<LuxuryFashionProcurement />} />
          <Route path="/automotive" element={<AutomotiveProcurement />} />
          <Route path="/medical-procurement" element={<MedicalProcurement />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;